<template>
  <div class="fund-detail-list">
    <a-card title="客户资金明细">
      <!-- 搜索表单 -->
      <div class="search-form">
        <a-form layout="inline">
          <a-row :gutter="16">
            <!-- 第一行：4个搜索条件 -->
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="客户编号"  :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-input v-model="queryParam.customerNo" placeholder="请输入客户编号"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="交易类型"  :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-select
                    v-model="queryParam.transactionType"
                    placeholder="请选择交易类型"
                >
                  <a-select-option :value="1">消费</a-select-option>
                  <a-select-option :value="2">充值</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="订单编号"  :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-input v-model="queryParam.orderNo" placeholder="请输入订单编号"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="支付方式"  :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-select
                    v-model="queryParam.paymentMethod"
                    placeholder="请选择支付方式"
                >
                  <a-select-option :value="1">支付宝</a-select-option>
                  <a-select-option :value="2">微信</a-select-option>
                  <a-select-option :value="3">三方充值</a-select-option>
                  <a-select-option :value="4">Payme</a-select-option>
                  <a-select-option :value="5">余额</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="12" :xs="24">
              <a-form-item label="交易时间" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
                <a-range-picker
                    v-model="queryParam.createTimeRange"
                    :placeholder="['开始时间', '结束时间']"
                    :show-time="{ format: 'HH:mm', defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')]}"
                    format="YYYY-MM-DD HH:mm:ss"
                    @change="onCreatDateChange"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <!-- 操作按钮 -->
        <div style="float: right;margin-bottom: 15px;margin-top: -45px">
          <a-button type="primary" @click="searchQuery(1)">搜索</a-button>
          <a-button style="margin-left: 8px" @click="searchReset({}, 1)">重置</a-button>
        </div>
      </div>

      <!-- 统计条 -->
      <div class="statistics-bar">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12" :xs="12">
            <a-card size="small" :bordered="false" class="stat-card recharge">
              <a-statistic
                :value="statistics.rechargeAmount || 0"
                :precision="2"
                suffix="UZS"
                :valueStyle="{ color: '#52c41a' }"
                class="inline-stat"
              >
                <template #title>
                  <span class="stat-title">
                    <img src="@/assets/img/svg/recharge.svg" alt="充值" class="stat-icon" />
                    充值
                  </span>
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :md="6" :sm="12" :xs="12">
            <a-card size="small" :bordered="false" class="stat-card consume">
              <a-statistic
                :value="statistics.consumeAmount || 0"
                :precision="2"
                suffix="UZS"
                :valueStyle="{ color: '#fa541c' }"
                class="inline-stat"
              >
                <template #title>
                  <span class="stat-title">
                    <img src="@/assets/img/svg/consume.svg" alt="消费" class="stat-icon" />
                    消费
                  </span>
                </template>
              </a-statistic>
            </a-card>
          </a-col>
        </a-row>
      </div>

      <!-- 表格 -->
      <a-table
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          bordered
          @change="handleTableChange"
          :scroll="{ x: tableScrollX }"
          rowKey="id"
      >
        <template slot="transactionType" slot-scope="text">
          <a-tag :color="text === 1 ? 'orange' : 'green'">
            {{ text === 1 ? '消费' : '充值' }}
          </a-tag>
        </template>

        <!-- 表格中的支付方式列 -->
        <template slot="paymentMethod" slot-scope="text">
          <a-tag :color="paymentMethodMap[text]?.color || 'default'">
            {{ paymentMethodMap[text]?.text || '未知' }}
          </a-tag>
        </template>

        <template slot="action" slot-scope="text, record">
          <a @click="showDetail(record)">详情</a>
        </template>
      </a-table>

      <!-- 详情弹框 -->
      <a-modal
          title="交易详情"
          :visible="detailVisible"
          @ok="handleDetailOk"
          @cancel="handleDetailCancel"
          width="800px"
      >
        <a-descriptions bordered :column="2" v-if="currentDetail">
          <a-descriptions-item label="交易ID">{{ currentDetail.id }}</a-descriptions-item>
          <a-descriptions-item label="客户编号">{{ currentDetail.customerNo }}</a-descriptions-item>

          <a-descriptions-item label="交易类型">
            <a-tag :color="currentDetail.transactionType === 1 ? 'orange' : 'green'">
              {{ currentDetail.transactionType === 1 ? '消费' : '充值' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="交易金额（UZS）">{{ currentDetail.amount }}</a-descriptions-item>

          <a-descriptions-item label="实付金额（UZS）">{{ currentDetail.payAmount }}</a-descriptions-item>
          <a-descriptions-item label="优惠金额（UZS）">{{ currentDetail.discountAmount }}</a-descriptions-item>

          <a-descriptions-item label="交易金额（USD）">{{ currentDetail.payAmountUs }}</a-descriptions-item>
          <a-descriptions-item label="积分金额（USD）">{{ currentDetail.points }}</a-descriptions-item>

          <a-descriptions-item label="订单编号">{{ currentDetail.orderNo || '-' }}</a-descriptions-item>
          <a-descriptions-item label="流水号">{{ currentDetail.serialNum || '-' }}</a-descriptions-item>

          <a-descriptions-item label="支付方式">
            <a-tag :color="paymentMethodMap[currentDetail.paymentMethod]?.color">
              {{ paymentMethodMap[currentDetail.paymentMethod]?.text }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="交易时间">{{ currentDetail.transactionTime }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ currentDetail.gmtCreate }}</a-descriptions-item>
        </a-descriptions>
        <!-- 新增底部关闭按钮插槽 -->
        <template slot="footer">
          <a-button key="close" type="primary" @click="handleDetailCancel">关闭</a-button>
        </template>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import {TableListMixin} from '@/situation/mixins/tableListMixin'

export default {
  name: "CustomerFlow",
  mixins: [TableListMixin],
  computed: {
    tableScrollX() {
      // 计算所有列宽之和
      return this.columns.reduce((sum, col) => sum + (col.width || 120), 0)
    }
  },
  data() {
    return {
      // 搜索表单
      searchForm: this.$form.createForm(this),
      queryParam: {},
      loading: false,
      detailVisible: false,
      currentDetail: null,
      paymentMethodMap: {
        1: {text: '支付宝', color: 'blue'},
        2: {text: '微信', color: 'green'},
        3: {text: '三方充值', color: 'orange'},
        4: {text: 'Payme', color: 'purple'},
        5: {text: '余额', color: 'cyan'}
      },
      columns: [
        {
          title: '客户编号',
          dataIndex: 'customerNo',
          key: 'customerNo',
          align: 'center',
          fixed: 'left',
          width: 120
        },
        {
          title: '交易类型',
          dataIndex: 'transactionType',
          key: 'transactionType',
          align: 'center',
          width: 100,
          scopedSlots: {customRender: 'transactionType'}
        },
        {
          title: '交易金额（UZS）',
          dataIndex: 'amount',
          key: 'amount',
          width: 140,
          align: 'center'
        }, {
          title: '实付金额（UZS）',
          dataIndex: 'payAmount',
          key: 'payAmount',
          width: 140,
          align: 'center'
        }, {
          title: '优惠金额（UZS）',
          dataIndex: 'discountAmount',
          key: 'discountAmount',
          width: 140,
          align: 'center'
        }, {
          title: '交易金额（USD）',
          dataIndex: 'payAmountUs',
          key: 'payAmountUs',
          width: 140,
          align: 'center'
        }, {
          title: '积分金额（USD）',
          dataIndex: 'points',
          key: 'points',
          width: 140,
          align: 'center'
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          key: 'orderNo',
          width: 150,
          align: 'center'
        }, {
          title: '流水号',
          dataIndex: 'serialNum',
          key: 'serialNum',
          width: 160,
          align: 'center'
        },
        {
          title: '支付方式',
          dataIndex: 'paymentMethod',
          key: 'paymentMethod',
          width: 100,
          align: 'center',
          scopedSlots: {customRender: 'paymentMethod'}
        },
        {
          title: '交易时间',
          dataIndex: 'transactionTime',
          key: 'transactionTime',
          width: 180,
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 100,
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ],
      url: {
        selectData: "/ndt/customerFundDetail/page",
        statistics: "/ndt/customerFundDetail/statistics",
        deleteData: "",
        exportXlsUrl: ""
      },
    }
  },
  mounted(){
    // 页面加载时获取统计数据
    this.dataStatistics();
  },
  methods: {
    onCreatDateChange: function (value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.startTime = dateString[0];
      this.queryParam.endTime = dateString[1];
    },
    showDetail(record) {
      this.currentDetail = record
      this.detailVisible = true
    },

    handleDetailOk() {
      this.detailVisible = false
    },

    handleDetailCancel() {
      this.detailVisible = false
    }
  }
}
</script>

<style scoped>
.fund-detail-list {
  background: #fff;
  padding: 16px;
}

.search-form {
  margin-bottom: 20px;
}

/* 统计条样式 */
.statistics-bar {
  margin: 12px 0 16px;
}
.stat-card.recharge .ant-statistic-title {
  color: #1890ff;
}
.stat-card.consume .ant-statistic-title {
  color: #fa8c16;
}

/* 表单行样式 */
.search-form .ant-row {
  display: flex;
  flex-wrap: wrap;
}

/* 表单项样式 */
.search-form .ant-form-item {
  margin-bottom: 16px;
  width: 100%;
}

/* 统一输入框和下拉框宽度 */
.search-form .form-item-custom .ant-input,
.search-form .form-item-custom .ant-select,
.search-form .form-item-custom .ant-picker {
  width: 100%;
}

/* 按钮容器样式 */
.form-actions-col {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .form-actions-col {
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .search-form .ant-form-item {
    margin-bottom: 12px;
  }
}
.inline-stat {
  display: flex;
  align-items: center;
  gap: 8px;
}
.inline-stat .ant-statistic-title {
  margin-bottom: 0;
}
.stat-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.stat-icon {
  width: 20px;
  height: 20px;
}
</style>
